import camelcaseKeys from 'camelcase-keys';

import { Account, AuthHeaderFn } from '@hcs/types';
import { AUTH_URL } from '@hcs/urls';

import { AxiosClient, queryClient } from '../clients';
import { ACCOUNT_QUERY_KEY } from '../constants';

const removeAllQueriesExceptAccount = () => {
  const queryCache = queryClient.getQueryCache();
  queryCache.getAll().forEach(({ queryKey }) => {
    if (queryKey.length === 1 && queryKey[0] === ACCOUNT_QUERY_KEY) {
      // leave the account query
    } else {
      queryClient.removeQueries(queryKey);
    }
  });
};

export const handleAccountUpdate = (account: Account) => {
  // Keep the account query, so the app doesn't log the user out
  removeAllQueriesExceptAccount();
  // Update the account information
  queryClient.setQueryData<Account>([ACCOUNT_QUERY_KEY], account);
};

export const handleInvalidToken = () => {
  // we need to reset the account query (as opposed to removing) so a refetch is triggered (and thus a re-render to it's subscribers)
  queryClient.resetQueries([ACCOUNT_QUERY_KEY]);
  removeAllQueriesExceptAccount();
};

export const getRequestAuthHeaders = () => ({
  'HC-Auth-Token': queryClient.getQueryData<Account>([ACCOUNT_QUERY_KEY])
    ?.validity.token,
});

export const authHeaderFnEhrmantraut: AuthHeaderFn = (
  token: string | null
) => ({
  'HC-Auth-Token': token || '',
});

export const authHeaderFnJwt: AuthHeaderFn = (token: string | null) => ({
  authorization: `JWT ${token}`,
});

export const fetchAccount = async () => {
  const response = await AxiosClient.post<Account>(
    `${AUTH_URL}/access-token`,
    undefined,
    {
      withCredentials: true,
    }
  );
  return camelcaseKeys(response.data, { deep: true });
};
